// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__10dC0","item":"PaymentsMobile_item__1Ysg9","label":"PaymentsMobile_label__Oq0bp","amount":"PaymentsMobile_amount__4IhV4"};